export default {
  '请求': {
    '加载中': 'กำลังโหลด',
    '请求失败': 'คำขอล้มเหลว',
    '登录已过期': 'เซสชันหมดอายุ',
    '网络连接失败': 'เชื่อมต่อเครือข่ายไม่สำเร็จ',
    '请重新登录': 'กรุณาเข้าสู่ระบบอีกครั้ง',
    '没有权限访问': 'ไม่มีสิทธิ์เข้าถึง',
    '请求的资源不存在': 'ไม่พบทรัพยากรที่ร้องขอ',
    '服务器错误': 'เซิร์ฟเวอร์ผิดพลาด',
    '网络错误': 'เครือข่ายผิดพลาด',
    '刷新成功': 'รีเฟรชสำเร็จ',
    '获取中': 'กำลังดึงข้อมูล......',
    '账号下线': 'บัญชีออฟไลน์',
    '功能已禁用': 'ฟีเจอร์ถูกปิดใช้งาน',
  },
  '导航': {
    '首页': 'หน้าแรก',
    '选妃': 'เลือก',
    '认证': 'ยืนยันตัวตน',
    '影院': 'วิดีโอ',
    '个人': 'ของฉัน',
  },
  '首页': {
    '注册': 'สมัครสมาชิก',
    '影片': 'วิดีโอ',
    '女团': 'สาวๆ',
    '热门城市': 'เมืองยอดนิยม：',
    '经理预订': 'จองผ่านผู้จัดการ',
    '看更多': 'ดูเพิ่มเติม',
    '身份验证': 'ยืนยันแล้ว',
    '身高': 'ส่วนสูง',
    '胸围': 'รอบอก',
    '服务城市': 'เมืองที่ให้บริการ：',
  },
  '女团': {
    '女团': 'สาวๆ',
    '选妃': 'เลือก',
    '身份验证': 'ยืนยันแล้ว',
    '身高': 'ส่วนสูง',
    '胸围': 'รอบอก',
    '服务城市': 'เมืองที่ให้บริการ:',
    '注册': 'สมัครสมาชิก',
    '请联系顾问或接待员': 'กรุณาติดต่อที่ปรึกษาหรือพนักงานต้อนรับ',
  },
  '登录': {
    '登录会员视窗': 'เข้าสู่ระบบสมาชิก',
    '请输入用户名': 'กรอกชื่อผู้ใช้',
    '请输入密码': 'กรอกรหัสผ่าน',
    '登录': 'เข้าสู่ระบบ',
    '没有账号马上注册': 'ยังไม่มีบัญชี? สมัครเลย',
    '登录成功': 'เข้าสู่ระบบสำเร็จ',
    '登录注册': 'เข้าสู่ระบบ / สมัครสมาชิก',
    '登录可享受更多服务': 'เข้าสู่ระบบเพื่อรับบริการเพิ่มเติม!',
  },
  '注册': {
    '注册': 'สมัครสมาชิก',
    '登录': 'เข้าสู่ระบบ',
    '请输入用户名': 'กรอกชื่อผู้ใช้',
    '用户名规则': 'ตัวอักษร/ตัวเลข 6-20 ตัว',
    '请输入密码': 'กรอกรหัสผ่าน',
    '密码规则': 'ตัวอักษรและตัวเลข 6-16 ตัว',
    '请输入验证码': 'กรอกรหัสยืนยัน',
    '验证码规则': 'กรอกรหัสยืนยัน 4 หลัก',
    '请输入邀请码': 'กรอกรหัสเชิญ',
    '邀请码规则': 'กรอกรหัสเชิญจากตัวแทน',
    '同意协议': 'ฉันอายุ 18 ปีขึ้นไป และยอมรับเงื่อนไขการสมัคร',
    '立即注册': 'สมัครทันที',
    '注册中': 'กำลังสมัคร...',
    '已有账号马上登录': 'มีบัญชีแล้ว? เข้าสู่ระบบ',
    '注册成功': 'สมัครสำเร็จ!',
    '注册失败': 'สมัครไม่สำเร็จ：',
    '验证码错误': 'รหัสยืนยันไม่ถูกต้อง',
    '请同意注册条款': 'กรุณายอมรับเงื่อนไขการสมัคร',
    '用户名已存在': 'ชื่อผู้ใช้ถูกใช้แล้ว',
    '邀请码无效': 'รหัสเชิญไม่ถูกต้อง',
  },
  '抢单': {
    '今日收益': 'รายได้วันนี้',
    '余额': 'ยอดคงเหลือ',
    '订单': 'คำสั่งซื้อ',
    '开始抢单': 'เริ่มรับออเดอร์',
    '当前等级': 'ระดับปัจจุบัน：',
    '提现': 'ถอนเงิน',
    '在线客服': 'ฝ่ายบริการออนไลน์',
    '充值': 'เติมเงิน',
    '幸运任务': 'ภารกิจโชคดี',
    '幸运订单': 'ออเดอร์โชคดี',
    '幸运订单提示': 'ยินดีด้วย! นี่คือออเดอร์ค่าคอมสูง',
    '恭喜获得幸运订单': 'ได้รับออเดอร์โชคดี!',
    '提交订单': 'ส่งคำสั่งซื้อ',
    '未完成订单提示': 'คุณมีคำสั่งซื้อที่ยังไม่เสร็จ กรุณาชำระเงินก่อนรับออเดอร์ใหม่',
    '正在获取订单': 'กำลังดึงคำสั่งซื้อ...',
    '抢单时间': 'เวลารับออเดอร์：',
    '订单号': 'หมายเลขคำสั่งซื้อ',
    '订单总额': 'ยอดรวม',
    '佣金': 'ค่าคอมมิชชัน',
    '商品单价': 'ราคาต่อหน่วย',
    '预计收入': 'รายได้โดยประมาณ',
    '确认支付': 'ยืนยันการชำระเงิน',
    '确认付款': 'ยืนยันการจ่าย',
    '支付处理中': 'กำลังดำเนินการชำระเงิน...',
    '取消': 'ยกเลิก',
    '去查看': 'ดูรายละเอียด',
    '暂无可用订单': 'ไม่มีคำสั่งซื้อที่ใช้ได้',
    '正在加载用户信息': 'กำลังโหลดข้อมูลผู้ใช้...',
    '今日抢单已达上限': 'ถึงขีดจำกัดรับออเดอร์วันนี้แล้ว',
    '余额不足无法获取订单': 'ยอดคงเหลือไม่พอ ไม่สามารถรับออเดอร์ได้',
    '获取订单失败': 'ดึงคำสั่งซื้อไม่สำเร็จ',
    '支付成功': 'ชำระเงินสำเร็จ',
    '支付失败': 'ชำระเงินไม่สำเร็จ',
    '支付失败请重试': 'ชำระเงินไม่สำเร็จ กรุณาลองใหม่',
    '请完成任务单后进入': 'กรุณาทำภารกิจให้เสร็จก่อนเข้า',
    '请设置收款卡': 'กรุณาตั้งค่าบัญชีรับเงิน',
  },
  '我的': {
    '我的页面': 'หน้าของฉัน',
    '钻石': 'เพชร',
    '信誉分': 'คะแนนเครดิต',
    '开通专属会员': 'เปิดสมาชิกพิเศษ',
    '开启一次日期不限': 'เปิดครั้งเดียว ไม่จำกัดวัน',
    '提现': 'ถอนเงิน',
    '历史订单': 'ประวัติคำสั่งซื้อ',
    '充值记录': 'ประวัติเติมเงิน',
    '提现记录': 'ประวัติถอนเงิน',
    '添加钱包地址': 'เพิ่มที่อยู่กระเป๋าเงิน',
    '邀请码': 'รหัสเชิญ：',
    '余额': 'ยอดคงเหลือ',
    '退出登陆': 'ออกจากระบบ',
  },
  '会员': {
    '会员等级': 'ระดับสมาชิก：',
    '普通等级': 'ระดับทั่วไป',
    '当前等级': 'ระดับปัจจุบัน',
    '立即开通': 'เปิดทันที',
    '免费说明': '(ดูวิดีโอฟรี) (จับคู่ฟรี)',
    '所需投资': 'เงินลงทุนที่ต้องใช้',
    '佣金': 'ค่าคอมมิชชัน',
    '订单': 'คำสั่งซื้อ',
    '加入': 'เข้าร่วม >>',
  },
  '充值': {
    '充值': 'เติมเงิน',
    '当前余额': 'ยอดคงเหลือปัจจุบัน',
    '余额': 'ยอดคงเหลือ：',
    '个': '',
    '充值金额': 'จำนวนเงินเติม',
    '请输入充值金额': 'กรอกจำนวนเงินเติม',
    '快速选择金额': 'เลือกจำนวนด่วน',
    '确认': 'ยืนยัน',
    '提示': 'คำแนะนำ',
    '金额错误': 'จำนวนเงินไม่ถูกต้อง',
    '立即充值': 'เติมเงินทันที',
    '提交成功': 'ส่งแล้ว กรุณารอการตรวจสอบ',
  },
  '提现': {
    '提现': 'ถอนเงิน',
    '兑换积分': 'แลกคะแนน',
    '最大提款金额': 'จำนวนถอนสูงสุด',
    '资金密码': 'รหัสผ่านกองทุน',
    '余额': 'ยอดคงเหลือ：',
    '个': '',
    '钱包地址': 'ที่อยู่กระเป๋าเงิน：',
    '请选择提款地址': 'เลือกที่อยู่ถอนเงิน',
    '暂无绑定地址': 'ยังไม่มีที่อยู่ที่ผูกไว้ กรุณาผูกก่อน',
    '提交': 'ส่ง',
    '通知': 'ประกาศ：',
    '单笔最大提现': '1、จำนวนถอนสูงสุดต่อครั้ง:',
    '单笔最低提现': '2、จำนวนถอนขั้นต่ำต่อครั้ง：',
    '检查姓名账号': '3、กรุณาตรวจสอบชื่อและบัญชีถอนเงิน',
    '注意提款费用': '4、โปรดระวังค่าธรรมเนียมการถอน',
    '请填写正确的金额': 'กรุณากรอกจำนวนเงินให้ถูกต้อง',
    '当前余额': 'ยอดคงเหลือปัจจุบัน',
    '提现金额': 'จำนวนถอน',
    '请输入提现数量': 'กรอกจำนวนที่ต้องการถอน',
    '立即提现': 'ถอนทันที',
    '交易密码': 'รหัสผ่านธุรกรรม',
    '请输入交易密码': 'กรอกรหัสผ่านธุรกรรม',
    '请先设置提现密码': 'กรุณาตั้งรหัสผ่านถอนเงินก่อน',
  },
  '绑卡': {
    '添加钱包地址': 'เพิ่มที่อยู่กระเป๋าเงิน',
    '钱包地址信息': 'ข้อมูลที่อยู่กระเป๋าเงิน',
    '请输入支付卡信息': 'กรอกที่อยู่กระเป๋าเงินของคุณ',
    '加密货币类型': 'ประเภทคริปโต',
    '请选择加密货币类型': 'เลือกประเภทคริปโต',
    '钱包地址': 'ที่อยู่กระเป๋า',
    '请输入钱包地址': 'กรอกที่อยู่กระเป๋า',
    '绑卡说明': 'เรียนผู้ใช้ เพื่อความปลอดภัยของเงินทุน กรุณาผูกชื่อจริงและตั้งรหัสผ่านถอนเงิน หากชื่อไม่ตรงกับชื่อบัญชี คุณจะไม่สามารถถอนเงินได้',
    '确定绑卡': 'ยืนยันการผูกบัตร',
    '绑卡提示': 'คำแนะนำ: ผูกกับธนาคารพาณิชย์รายใหญ่ หากต้องการแก้ไข กรุณาติดต่อฝ่ายบริการออนไลน์',
    '请先设置姓名': 'กรุณาตั้งชื่อก่อนผูกที่อยู่กระเป๋าเงิน!',
    '已绑定不可修改': 'ที่อยู่ถอนเงินถูกผูกแล้ว หากต้องการแก้ไข กรุณาติดต่อฝ่ายบริการ',
  },
  '订单历史': {
    '订单历史': 'ประวัติคำสั่งซื้อ',
    '数据为空': 'ไม่มีข้อมูล',
    '订单号': 'หมายเลขคำสั่งซื้อ：',
    '已完成': 'เสร็จสิ้น',
    '处理中': 'กำลังดำเนินการ',
    '完成订单': 'ทำคำสั่งซื้อให้เสร็จ',
    '订单金额': 'ยอดคำสั่งซื้อ：',
    '佣金': 'ค่าคอมมิชชัน：',
    '创建时间': 'เวลาสร้าง：',
    '上一页': 'ก่อนหน้า',
    '下一页': 'ถัดไป',
    '获取失败': 'ดึงประวัติคำสั่งซื้อไม่สำเร็จ',
    '获取失败重试': 'ดึงประวัติไม่สำเร็จ กรุณาลองใหม่',
    '未知': 'ไม่ทราบ',
    '完成成功': 'ทำคำสั่งซื้อเสร็จสิ้นแล้ว!',
    '完成失败': 'ทำคำสั่งซื้อไม่สำเร็จ：',
    '完成失败重试': 'ทำคำสั่งซื้อไม่สำเร็จ กรุณาลองใหม่',
    '请输入支付密码': 'กรุณาใส่รหัสผ่านการชำระเงิน',
    '请先设置支付密码': 'กรุณาตั้งรหัสผ่านการชำระเงินก่อน',
  },
  '入金记录': {
    '标题': 'ประวัติเติมเงิน',
    '数据为空': 'ไม่มีข้อมูล',
    '认证结果': 'ผลการตรวจสอบ',
    '下单积分': 'คะแนนสั่งซื้อ：',
    '下单时间': 'เวลาสั่งซื้อ：',
    '结算时间': 'เวลาชำระบัญชี：',
    '待审核': 'รอตรวจสอบ',
    '已通过': 'อนุมัติแล้ว',
    '已拒绝': 'ปฏิเสธแล้ว',
    '暂无数据': 'ไม่มีข้อมูล',
  },
  '提现记录': {
    '标题': 'ประวัติถอนเงิน',
    '数据为空': 'ไม่มีข้อมูล',
    '待审核': 'รอตรวจสอบ',
    '审核成功': 'ตรวจสอบผ่าน',
    '审核退回': 'ตรวจสอบไม่ผ่าน',
    '未知状态': 'สถานะไม่ทราบ',
    '金额': 'จำนวน：',
    '说明': 'รายละเอียด：',
    '提交时间': 'เวลาส่ง：',
    '审核时间': 'เวลาตรวจสอบ：',
    '已通过': 'อนุมัติแล้ว',
    '已拒绝': 'ปฏิเสธแล้ว',
    '暂无数据': 'ไม่มีข้อมูล',
  },
  '资料': {
    '基本信息': 'ข้อมูลพื้นฐาน',
    '头像': 'รูปโปรไฟล์',
    '姓名': 'ชื่อ',
    '未设置': 'ยังไม่ตั้งค่า',
    '性别': 'เพศ',
    '男': 'ชาย',
    '女': 'หญิง',
    '未知': 'ไม่ทราบ',
    '设定': 'ตั้งค่า',
    '账号信息': 'ข้อมูลบัญชี',
    '更改登录密码': 'เปลี่ยนรหัสผ่านเข้าสู่ระบบ',
    '设定支付密码': 'ตั้งรหัสผ่านชำระเงิน',
    '退出登录': 'ออกจากระบบ',
    '设置': 'ตั้งค่า',
    '登录密码': 'รหัสผ่านเข้าสู่ระบบ',
    '资金密码': 'รหัสผ่านกองทุน',
    '提现密码已设置': 'ตั้งรหัสผ่านถอนเงินแล้ว หากต้องการเปลี่ยน กรุณาติดต่อฝ่ายบริการ',
    '已设置': 'ตั้งค่าแล้ว',
    '修改真实姓名': 'แก้ไขชื่อจริง',
    '请输入真实姓名': 'กรอกชื่อจริง',
    '真实姓名说明': 'เพื่อความปลอดภัยของบัญชี ชื่อจริงต้องตรงกับข้อมูลกระเป๋าเงินที่ผูกไว้',
    '提交': 'ส่ง',
    '请勿重复设置': 'อย่าตั้งค่าซ้ำ!',
    '修改登录密码': 'เปลี่ยนรหัสผ่านเข้าสู่ระบบ',
    '设置资金密码': 'ตั้งรหัสผ่านกองทุน',
    '保存': 'บันทึก',
    '旧密码': 'รหัสผ่านเดิม',
    '请输入旧密码': 'กรอกรหัสผ่านเดิม',
    '新密码': 'รหัสผ่านใหม่',
    '请输入新密码': 'กรอกรหัสผ่านใหม่',
    '确认密码': 'ยืนยันรหัสผ่าน',
    '请再次输入新密码': 'กรอกรหัสผ่านใหม่อีกครั้ง',
    '请填写完整': 'กรุณากรอกให้ครบ!',
    '两次密码不一致': 'รหัสผ่านไม่ตรงกัน',
    '性别修改': 'แก้ไขเพศ',
    '个人报表': 'รายงานส่วนตัว',
    '任务金额积分': 'ยอดภารกิจ (คะแนน)',
    '盈利公式': 'สูตรกำไร : ยอดชนะ - ยอดภารกิจ',
    '任务金额': 'ยอดภารกิจ',
    '充值金额': 'ยอดเติมเงิน',
    '金额': 'จำนวนเงิน',
    '中奖金额': 'ยอดชนะ',
    '个人情报': 'ข้อมูลส่วนตัว',
    '身高': 'ส่วนสูง:',
    '胸围': 'รอบอก：',
    '收费区间': 'ช่วงราคา：',
    '系统公告': 'ประกาศระบบ',
  },
  '客服': {
    '联系客服': 'ติดต่อฝ่ายบริการ',
    '在线客服': 'ฝ่ายบริการออนไลน์',
    '暂无客服': 'ไม่มีฝ่ายบริการในขณะนี้',
    '联系': 'ติดต่อ',
    '服务时间': 'บริการตลอด 24 ชั่วโมงทุกวัน',
  },
  '影院': {
    '影院': 'โรงภาพยนตร์',
    '全部': 'ทั้งหมด',
    '最高分': 'คะแนนสูงสุด',
    '播放': 'เล่น :',
    '次播放': ' ครั้ง',
    '热门推荐': 'แนะนำยอดนิยม',
    '播放次数': 'เล่น:',
    '请充值后观看': 'กรุณาเติมเงินก่อนรับชมวิดีโอ',
  },
  '语言切换器': {
    '切换语言': 'เปลี่ยนภาษา',
    '语言': 'ภาษา',
  },
}
